// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"Login_errorMessage__G7KCX","forgot-password":"Login_forgot-password__2AAXu"};